import React from 'react';

export default function HotColdTab({ game, sortedByFreq, bonusEntries, getBallClass, ballView, setBallView }) {
  return (
    <>
      <div className="sub-toggle">
        <button
          className={`mode-btn ${ballView === 'main' ? 'active' : ''}`}
          onClick={() => setBallView('main')}
        >
          Main balls
        </button>
        <button
          className={`mode-btn ${ballView === 'bonus' ? 'active' : ''}`}
          onClick={() => setBallView('bonus')}
        >
          {game.bonusName}
        </button>
      </div>

      {ballView === 'main' && (
        <>
          <div className="legend">
            {[['#D85A30', 'High frequency (top 20%)'], ['#EF9F27', 'Above average (top 40%)'], ['#888780', 'Average'], ['#378ADD', 'Below average (bottom 20%)']].map(
              ([c, l]) => (
                <div className="legend-item" key={l}>
                  <div className="legend-dot" style={{ background: c }}></div>{l}
                </div>
              )
            )}
          </div>
          <div className="balls-grid">
            {sortedByFreq.map(({ n, f }) => (
              <div className="ball-item" key={n}>
                <div className={`ball ${getBallClass(f)}`}>{n}</div>
                <div className="ball-count">{f}x</div>
              </div>
            ))}
          </div>
        </>
      )}

      {ballView === 'bonus' && (
        <div className="balls-grid" style={{ marginTop: '0.75rem' }}>
          {bonusEntries.map(({ n, f }) => (
            <div className="ball-item" key={n}>
              <div
                className="ball"
                style={{
                  background: `${game.bonusColor}22`,
                  borderColor: game.bonusColor,
                  color: game.bonusColor,
                }}
              >
                {n}
              </div>
              <div className="ball-count">{f}x</div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
